import { BrowserRouter, Routes, Route } from "react-router-dom";
import NavBar from "./components/NavBar/NavBar";
import Home from "./pages/Home/Home";
import IP from "./pages/IP/IP";
import IPDetail from "./pages/IP/IPDetail";
import Mac from "./pages/Mac/Mac";
import MacDetail from "./pages/Mac/MacDetail";
import Accesories from "./pages/Accesories/Accesories";
import AboutUs from "./pages/AboutUs/AboutUs";
import PreFooter from "./components/PreFooter/PreFooter";
import Footer from "./components/Footer/Footer";
import "./App.scss";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <NavBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/iPhone" element={<IP />} />
          <Route path="/iPhoneDetail/:id" element={<IPDetail />} />
          <Route path="/Mac" element={<Mac />} />
          <Route path="/MacDetail/:id" element={<MacDetail />} />
          <Route path="/Accesories" element={<Accesories />} />
          <Route path="/AboutUs" element={<AboutUs />} />
        </Routes>
        <PreFooter/>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
